
      const title = import.meta.env.VITE_TITLE || 'TITLE_NOT_SET';
      const baseUrl = import.meta.env.VITE_BASE_URL || '/';
      document.querySelector('base').setAttribute('href', baseUrl);

      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.href = `${baseUrl}favicon.ico`;
      document.head.appendChild(favicon);
    